<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="over"> </p>
<p class="CT"><span href="#/xhtml/contents#c_over" title="Link target outside of Sample"><span class="ePub-B">OVERHEARD</span></span></p>
<p class="CO">“My feeling for Mike is something out of the ordinary,” I overhear my aunt say to my mother one day when I am eight years old. “It’s stronger than I am. I cannot explain it. He’s simply the most marvelous child I have ever known, and I love him beyond life itself.”</p>
<p class="TX"><span class="ePub-I">Beyond life itself</span>. At first I feel lucky to be so cherished, singled out to receive a love that is so vast … but then I stop to think about it. I am not sure what it means, really, to be loved <span class="ePub-I">beyond life itself</span>.</p>
<p class="TX">Do I love my own mother that way? Does she me? Is such a thing even possible?</p>
<p class="TX">And why me and not my two younger brothers? What do I have that they do not?</p>
<p class="TX">“I wish he were mine,” my aunt blurts after a moment.</p>
<p class="TX">From where I am crouching on the stairs in the entry hall, I can feel the weather in the room change. A long, tense pause opens up between the two women. I hear them breathing, back and forth, into that pause.</p>
<p class="TX">They are sitting at right angles to each other, I know, my aunt on the sofa, my mother in the chair next to it. This is how they always sit in our living room, not face-to-face but perpendicular, so that they don’t have to make eye contact if they don’t want to.</p>
<p class="TX">“I wish you had a child of your own,” my mother says carefully. Ever the second fiddle, the third born. The diplomat.</p>
<p class="TX">“So do I,” says my aunt in a pitched, emotional voice.</p>
<p class="TX"><span class="ePub-I">Maybe you would be a different person if you did</span>.</p>
<p class="TX">My mother does not say this. She thinks it, though. Everybody in our family does. But that’s not what happened.</p>
<p class="TX">This is.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// over.vue?148bfa0a